import React from 'react';
import './css/RegistrationPopup.css';

const RegistrationPopup = ({ isOpen, onClose, type, title, message, subaccountCode, isRealAccount }) => {
  // Auto-close after 3 seconds and redirect
  React.useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
        window.location.href = '/';
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const getPopupContent = () => {
    switch (type) {
      case 'success_real':
        return {
          icon: '✅',
          title: 'Account Created Successfully!',
          message: (
            <div>
              <p>You can now create events and receive payments.</p>
            </div>
          )
        };
      
      case 'success_test':
        return {
          icon: '✅',
          title: 'Account Created Successfully!',
          message: (
            <div>
              <p>{message}</p>
              <p>You can now create events and test the system.</p>
            </div>
          )
        };
      
      case 'success_customer':
        return {
          icon: '✅',
          title: 'Account Created Successfully!',
          message: (
            <div>
              <p>You can now log in and purchase tickets.</p>
            </div>
          )
        };
      
      case 'warning':
        return {
          icon: '⚠️',
          title: 'Account Created but Payment Setup Incomplete!',
          message: (
            <div>
              <p>{message}</p>
              <p>You can update your banking details later in your profile.</p>
            </div>
          )
        };
      
      default:
        return {
          icon: '✅',
          title: 'Registration Successful!',
          message: <p>{message}</p>
        };
    }
  };

  const content = getPopupContent();

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <span className="popup-icon">{content.icon}</span>
          <h2 className="popup-title">{content.title}</h2>
        </div>
        
        <div className="popup-body">
          {content.message}
        </div>
      </div>
    </div>
  );
};

export default RegistrationPopup;
